export const linkUrl = "https://dental.jharanadental.com.np/api"
export const imgUrl = "https://dental.jharanadental.com.np/"

